import { Hash, Loader2, MailCheck } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Field } from '@/components/common/FormBits'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'

type Props = {
  id: string
  value: string
  onChange: (v: string) => void
  error?: string
  onResend: () => void
  resending: boolean
}

/** Parola değişimi 2. adımı: e-postaya gelen 6 haneli kod. */
export function PasswordOtpStep({ id, value, onChange, error, onResend, resending }: Props) {
  const { t } = useTranslation()
  return (
    <div className="space-y-3 rounded-xl border border-primary/20 bg-primary/[0.04] p-3">
      <p className="flex items-start gap-2 text-sm">
        <MailCheck className="mt-0.5 size-4 shrink-0 text-primary" aria-hidden />
        {t('account.otpSent')}
      </p>
      <Field id={id} label={t('auth.otp')} error={error}>
        <div className="relative">
          <Hash className="pointer-events-none absolute left-2.5 top-1/2 size-4 -translate-y-1/2 text-muted-foreground" aria-hidden />
          <Input
            id={id}
            inputMode="numeric"
            maxLength={6}
            autoComplete="one-time-code"
            className="pl-8 font-mono tracking-[0.3em]"
            aria-invalid={!!error}
            value={value}
            onChange={(e) => onChange(e.target.value.replace(/\D/g, '').slice(0, 6))}
          />
        </div>
      </Field>
      <Button type="button" variant="link" size="sm" className="h-auto p-0" onClick={onResend} disabled={resending}>
        {resending ? <Loader2 className="animate-spin" /> : null}
        {t('account.resendCode')}
      </Button>
    </div>
  )
}
